module.exports = "/assets/data/9ec15709c8475015a88081ae92130ac1-WN7.data.json";